VP = window.VP || {};

(function( $ ) {

	var CLASSNAME = {
		expandable: 'expandable',
		expanded: 'vp-location-reference--expanded',
	};

	VP.locationReferenceModule = {

		/*
		 * Google API Key.
		 * Can get one from https://developers.google.com/maps/documentation/geocoding/start
		 */
		APIKey: VP_global.gmaps_key,

		wrapper: $('.vp-module__location-reference'),
		viewAll: null,
		extra: null,
		map: null,
		circle: null,
		mapLabel: null,
		geocoder: null,
		mapStyle: null,
		bounds: null,

		init: function () {
			var _this = this;

			if( _this.wrapper.length === 0 ) {
				return;
			}

			_this.setClasses();
			_this.eventHandlers();
			_this.generateMap();
		},

		setClasses: function() {
			var _this = this;
			// _this.extra = $('.vp-location-reference__extra');
			_this.viewAll = $('.vp-location-reference__view-all');

			return; // disable view all / expandable content

			// Check if content is overflowing, add necessary classes accordingly
			var wrapperHeight = _this.wrapper[0].clientHeight;
			var contentHeight = _this.wrapper[0].scrollHeight;

			if ( contentHeight >  wrapperHeight ) {
				// Make expandable
				_this.wrapper.addClass('expandable');
			}
		},

		eventHandlers: function() {
			var _this = this;

			// Hide/Show Info Toggler
			_this.viewAll.on('click', function(e) {
				e.preventDefault();
				if( !_this.wrapper.hasClass(CLASSNAME.expanded) ) {
					_this.expand();
				} else {
					_this.collapse();
				}
			});

			// Recenter map and reset zoom level on breakpoint change
			VP.breakpoint.onChange(function() {
				if( _this.map !== null && ( typeof _this.circle !== 'undefined' ) ) {
					_this.map.fitBounds(_this.circle.getBounds());
				}
			});
		},

		// Show more info
		expand: function() {
			var _this = this;

			var currentHeight = _this.wrapper[0].clientHeight;
			var targetHeight = _this.wrapper[0].scrollHeight;

			_this.wrapper
				.css( { 'height': currentHeight, 'max-height': 'none' })
				.stop()
				.animate({ height: targetHeight }, 300, function () {
					_this.wrapper
						.css( 'height', '' )
						.addClass(CLASSNAME.expanded);
				});

			_this.viewAll.addClass('vp-location-reference__view-all--expanded');
			_this.viewAll.text('Hide All Info');
		},

		// Hide info
		collapse: function() {
			var _this = this;

			// Reset state to get target collapsed height
			_this.wrapper
				.css( 'max-height', '' )
				.removeClass( CLASSNAME.expanded );

			var targetHeight = _this.wrapper[0].clientHeight;

			// Animate height
			_this.wrapper
				.addClass( CLASSNAME.expanded )
				.css({ 'height': _this.wrapper[0].clientHeight, 'max-height': 'none' })
				.animate({ height: targetHeight }, 300, function () {
					_this.wrapper
						.css( { 'height': '', 'max-height': '' } )
						.removeClass(CLASSNAME.expanded);
				});

			_this.viewAll.removeClass('vp-location-reference__view-all--expanded');
			_this.viewAll.text('View All Info');

			// Scroll to module
			$('html, body').animate({ scrollTop: _this.wrapper.offset().top - 100 }, 300);
		},

		generateMap: function() {
			var _this = this;

			if( $('.vp-location-reference__map').length === 0 ) {
				return;
			}

			/*
			 * Get map styling from /wp-content/themes/visitphilly/lib/google-map-style.json
			 * JSON generated from https://mapstyle.withgoogle.com/
			 */
			var jqxhr = $.getJSON( "/wp-content/themes/visitphilly/lib/google-map-style.json")
				.done(function() {
					_this.mapStyle = jqxhr.responseJSON;

					if (typeof google === 'object' && typeof google.maps === 'object') {
						_this.locationReferenceModule.initMap();
					} else {
						var $map = $('.vp-location-reference__map');
						VP.helpers.loadScript('https://maps.googleapis.com/maps/api/js?key=' + $map.data('api-key') + '&callback=VP.locationReferenceModule.initMap');
					}
				})
				.fail(function() {
					// @NOTE(IK): debug log, commented out by default
					// console.log( "Cannot load map style" );
				});
		},

		// Generate map
		initMap: function() {
			var _this = this;
			var _map = 'vp-location-reference__map';
			var $map = $('.' + _map);
			var clickablemarkers = true;
			var clickablecircle = false;
			var draggablemap = true;
			var clicklink = "";
			var clat = parseFloat($map.data('lat'));
			var clng = parseFloat($map.data('lng'));


			if( $map.data('mapsurl') != '' ) {
				clicklink = $map.data('mapsurl');
			}
			else {
				// https://www.google.com/maps/?q=39.9558087,-75.15041099999996
				clicklink = "https://www.google.com/maps/?q=" + $map.data('lat') + "," + $map.data('lng');
			}

			if( $map.data('arealink') != '' ) {
				clicklink = $map.data('arealink');
				clickablecircle = true;
			}

			// if mobile, no drag, just click
			if ( VP.helpers.isMobile() ) {
				draggablemap = false;
				clickablemarkers = false;
				$map.on('click', function(e) {
					e.preventDefault();
					window.open( clicklink );
					return false;
				});
			}

			_this.map = new google.maps.Map(document.getElementById(_map), {
				zoom: 14,
				draggable: draggablemap,
				zoomControl: false,
				scaleControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				mapTypeControl: false,
				center: {lat: clat, lng: clng}
			});

			styledMapType = new google.maps.StyledMapType(_this.mapStyle,{name: 'Styled Map'});
			_this.map.mapTypes.set('styled_map', styledMapType);
			_this.map.setMapTypeId('styled_map');

			_this.bounds = new google.maps.LatLngBounds();

			var pos = new google.maps.LatLng($map.data('lat'), $map.data('lng'));

			if( $map.data('type') === 'marker' ) {
				var markerZoomLevel = _this.setZoomLevel($map.data('rad'));
				_this.map.setZoom(markerZoomLevel);

				var marker = new google.maps.Marker({
					map: _this.map,
					position: pos,
					clickable: clickablemarkers,
				});

				if (clickablemarkers) {
					marker.addListener('click', function() {
						window.open( clicklink );
					});
				}

			} else {
				_this.circle = new google.maps.Circle({
					map: _this.map,
					radius: $map.data('rad'),
					fillColor: '#E73F3F',
					strokeColor: 'transparent',
					center: pos,
					clickable: clickablecircle
				});

				if (clickablecircle) {
					_this.circle.addListener('click', function() {
						window.open( clicklink );
					});
				}

				/*
				 * Need to use markerwithlabel library to style the text within the circle
				 * Getting script locally but included CDN url if we want to change it in the future
				 * CDN: https://cdn.sobekrepository.org/includes/gmaps-markerwithlabel/1.9.1/gmaps-markerwithlabel-1.9.1.min.js
				 */
				if (typeof MarkerWithLabel !== 'object') {
					VP.helpers.loadScript('/wp-content/themes/visitphilly/dist/scripts/gmaps-markerwithlabel-1.9.1.min.js', function() {
						_this.mapLabel = new MarkerWithLabel({
							map: _this.map,
							position: pos,
							labelContent: $map.data('area'),
							labelAnchor: new google.maps.Point(0, 0),
							labelClass: "vp-map-label vp-location-reference__map-area-label",
							labelInBackground: true,
							icon: ' '
						});
					});
				} else {
					_this.mapLabel = new MarkerWithLabel({
						map: _this.map,
						position: pos,
						labelContent: $map.data('area'),
						labelAnchor: new google.maps.Point(0, 0),
						labelClass: "vp-map-label vp-location-reference__map-area-label",
						labelInBackground: true,
						icon: ' '
					});
				}
			}

			// add loaded class when map is done loading
			// Explore Neighborhood module listens for this class if Location Reference module is in the page.
			 $('#vp-location-reference__map').addClass("vp-location-reference__map--loaded");

			// add area for map centering
			_this.bounds.extend(pos);

			if( $map.data('type') === 'circle' ) {
				_this.map.fitBounds(_this.circle.getBounds());
			}
		},

		// Set zoom level based on the location radius for Marker without the circle
		setZoomLevel: function(radius) {
			// default zoom
			var zoomLevel = 14;

			switch (true) {
				case (radius >= 1000):
					zoomLevel = 11;
					break;
				case (radius >= 750):
					zoomLevel = 12;
					break;
				case (radius >= 500):
					zoomLevel = 13;
					break;
				case (radius >= 300):
					zoomLevel = 14;
					break;
				case (radius >= 150):
					zoomLevel = 15;
					break;
				default:
					zoomLevel = 16;
				}

			return zoomLevel;
		}

	};
})(jQuery);
